import { motion, AnimatePresence } from 'framer-motion';
import { GitCompare } from 'lucide-react';
import { useCompare } from '../context/CompareContext';

interface FloatingCompareButtonProps {
  onClick: () => void;
}

export default function FloatingCompareButton({ onClick }: FloatingCompareButtonProps) {
  const { compareList, maxCompare } = useCompare();

  if (compareList.length === 0) return null;

  return (
    <AnimatePresence>
      <motion.button
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0, opacity: 0 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onClick}
        className="fixed bottom-8 right-8 z-40 flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-primary-600 to-secondary-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-shadow"
      >
        <GitCompare className="w-6 h-6" />
        <div className="flex flex-col items-start">
          <span className="font-bold text-lg">
            Compare ({compareList.length}/{maxCompare})
          </span>
          <span className="text-xs text-white/80">
            {maxCompare - compareList.length === 0 
              ? 'View comparison' 
              : `Add ${maxCompare - compareList.length} more`}
          </span>
        </div>
      </motion.button>
    </AnimatePresence>
  );
}
